'use client';

import { createContext, useContext, PropsWithChildren } from 'react';
import IDeal from '@/creditflowresearch/domain/vo/IDeal';
import { ICorporateDeal } from '@/creditflowresearch/domain/vo/Deals/CorporateDeal';
import { useIsGuest } from '@/creditflowresearch/application/User/access/hooks/useIsGuest';
import { useDealAccessGrant } from './useDealAccessGrant';

/**
 * True only inside a deal card that the opening period leaves open. Everywhere else the
 * default keeps the existing behaviour, so a tile shared with the overview pages is
 * unaffected there.
 *
 * TODO: remove when the European market opening period ends
 */
const OpenAccessDealContext = createContext<boolean>(false);

export const useIsOpenAccessDeal = (): boolean => useContext(OpenAccessDealContext);

/**
 * A guest is restricted everywhere except inside an open deal card.
 *
 * TODO: remove when the European market opening period ends — callers go back to useIsGuest
 */
export const useIsRestrictedGuest = (): boolean => {
  const isGuest = useIsGuest();
  const isOpenAccessDeal = useIsOpenAccessDeal();

  return isGuest && !isOpenAccessDeal;
};

interface IOpenAccessDealProviderProps extends PropsWithChildren {
  deal?: IDeal | ICorporateDeal,
}

export const OpenAccessDealProvider = ({ deal, children }: IOpenAccessDealProviderProps) => (
  <OpenAccessDealContext.Provider value={ useDealAccessGrant(deal) }>
    { children }
  </OpenAccessDealContext.Provider>
);
